<script>
  import { router } from '@inertiajs/svelte'

  let { board = {}, categories = [], recent_posts = [], flash = {} } = $props()

  function getTypeLabel(type) {
    const labels = { public: '공개', verified_only: '인증회원 전용', admin_only: '관리자 전용' }
    return labels[type] || type
  }

  function handleDelete() {
    if (confirm(`"${board.name}" 게시판을 삭제하시겠습니까?`)) {
      router.delete(`/admin/boards/${board.id}`)
    }
  }
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/boards" class="hover:text-primary transition-colors">게시판</a>
    <span>/</span>
    <span class="text-content">{board.name}</span>
  </div>

  {#if flash.alert}
    <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
      {flash.alert}
    </div>
  {/if}

  <main class="space-y-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <div>
        <h2 class="text-h1 text-content">{board.name}</h2>
        <p class="text-body2 text-content-tertiary mt-1">/{board.slug}</p>
      </div>
      <div class="flex items-center gap-3">
        <a href={`/admin/boards/${board.id}/edit`} class="btn btn-secondary btn-md">수정</a>
        <button onclick={handleDelete} class="btn btn-error btn-md">삭제</button>
      </div>
    </div>

    <!-- Board Details -->
    <div class="card card-bordered p-6 shadow-md">
      <h3 class="text-title text-content mb-4">게시판 정보</h3>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <div class="text-caption text-content-tertiary">유형</div>
          <div class="text-body1 font-medium text-content mt-1">{getTypeLabel(board.board_type)}</div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">게시글 수</div>
          <div class="text-body1 font-medium text-content mt-1">{board.posts_count}</div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">익명 허용</div>
          <div class="text-body1 font-medium mt-1 {board.allow_anonymous ? 'text-success' : 'text-content-tertiary'}">{board.allow_anonymous ? '예' : '아니오'}</div>
        </div>
        <div>
          <div class="text-caption text-content-tertiary">사전 검토</div>
          <div class="text-body1 font-medium mt-1 {board.require_moderation ? 'text-warning-dark dark:text-warning' : 'text-content-tertiary'}">{board.require_moderation ? '예' : '아니오'}</div>
        </div>
      </div>
      {#if board.description}
        <div class="mt-4 pt-4 border-t border-default">
          <div class="text-caption text-content-tertiary mb-1">설명</div>
          <p class="text-body1 text-gray-700 dark:text-dark-text-medium">{board.description}</p>
        </div>
      {/if}
      <div class="mt-4 pt-4 border-t border-default text-caption text-content-tertiary">
        생성: {new Date(board.created_at).toLocaleDateString('ko-KR')} | 수정: {new Date(board.updated_at).toLocaleDateString('ko-KR')}
      </div>
    </div>

    <!-- Connected Categories -->
    <div class="card card-bordered p-6 shadow-md">
      <h3 class="text-title text-content mb-4">연결된 카테고리 ({categories.length})</h3>
      {#if categories.length > 0}
        <div class="flex flex-wrap gap-2">
          {#each categories as category}
            <a href={`/admin/categories/${category.id}`} class="inline-flex items-center gap-2 px-3 py-1.5 bg-surface-tertiary rounded-lg hover:bg-gray-200 dark:hover:bg-dark-border transition-colors">
              {#if category.color}
                <span class="w-3 h-3 rounded-full" style="background-color: {category.color}"></span>
              {/if}
              <span class="text-body2 text-gray-700 dark:text-dark-text-medium">{category.name}</span>
            </a>
          {/each}
        </div>
      {:else}
        <p class="text-body2 text-content-tertiary">연결된 카테고리가 없습니다</p>
      {/if}
    </div>

    <!-- Recent Posts -->
    <div class="card card-bordered overflow-hidden shadow-md">
      <div class="px-6 py-4 border-b border-default">
        <h3 class="text-title text-content">최근 게시글</h3>
      </div>
      {#if recent_posts.length > 0}
        <div class="divide-y divide-gray-100 dark:divide-dark-border">
          {#each recent_posts as post}
            <a href={`/admin/posts/${post.id}`} class="block px-6 py-3 hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
              <div class="flex items-center justify-between">
                <span class="text-body2 text-content">{post.title}</span>
                <span class="text-caption text-content-tertiary">{post.user_name} · {new Date(post.created_at).toLocaleDateString('ko-KR')}</span>
              </div>
            </a>
          {/each}
        </div>
      {:else}
        <div class="px-6 py-8 text-center text-content-tertiary">게시글이 없습니다</div>
      {/if}
    </div>
  </main>
